import React from 'react';
import { connect } from 'react-redux';
import { setDialogs } from '../../../actions';
import './index.scss';

class ActionSuccessDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.from = this.props.from;
    this.Log = this.props.Log;
  }

  componentDidMount() {
    switch (this.from) {
      case 'exchange':
        this.Log && this.Log.sendExposure({
          element_type: 'exchange',
                	element_name: 'exchange_popup_success',
        });
        break;
      default:
        break;
    }
  }

	close = () => {
	  this.props.dialogs.pop();
	  this.props.dispatch(setDialogs(this.props.dialogs));
	  this.props.onOkCbk && this.props.onOkCbk();
	}

	// 去福利中心主页
	toWelfareIndex = () => {
	  this.props.dialogs.pop();
	  this.props.history.push({ pathname: '/' });
	}

	// 去提现
	toWithdraw = () => {
	  this.props.dialogs.pop();
	  this.props.history.push({ pathname: '/withDraw' });
	}

	// 点击按钮渲染
	btnRender = () => {
	  const { from } = this.props;

	  if (from === 'withdraw') {
	    return <div className="btn" onClick={this.toWelfareIndex} log-click-eltype="confirm">继续赚现金</div>;
	  } if (from === 'exchange') {
	    return (
				<div className="exDialogBtn">
					<div className="btnItem income" onClick={this.toWelfareIndex}>继续赚金币</div>
					<div className="btnItem withdraw" onClick={this.toWithdraw}>去提现</div>
				</div>
	    );
	  } if (from === 'signInMoney') {
	    return (
				<React.Fragment>
					<div className="btn mid" onClick={this.close} log-click-eltype="confirm">知道了</div>
					<div className="withdrawTip">签到越多，可提更多哦～</div>
				</React.Fragment>
	    );
	  }
	  return <div className="btn" onClick={this.close} log-click-eltype="confirm">知道了</div>;
	}

	render() {
	  const { from, title, subTitle } = this.props;

	  return (
			<div className="actionSuccessDialog">
				<div className="dialog">
					{(from === 'withdraw' || from == 'exchange')
						&& <div className="close" onClick={this.close} log-click-eltype="cancel"></div>
					}
					<div className="chahua"></div>
					<div className="success">{title}</div>
					<div className="successTip">{subTitle}</div>
					{this.btnRender()}
				</div>
			</div>
	  );
	}
}

const mapStateToProps = (state) => {
  const { dialogs } = state;
  return {
    dialogs,
  };
};

export default connect(mapStateToProps)(ActionSuccessDialog);
